import { IRefIds } from 'constants/refs';
import { getCacheKey } from 'helpers/cache';
import { useCacheData } from 'hooks/useCacheData';
import React, { useCallback, useMemo } from 'react';
import CoursesSelectModel from '../../models/CoursesSelectModel';
import { ICourse } from '../../types/courses';
import RefSelectorList, { IRefOption } from '../RefSelectorList';

type IProps = {
  currentValue: number[];
  onChange: (courseIds: number[]) => void;
  skipCourseId?: number;
  className?: string;
};

const CourseSelectMulti: React.FC<IProps> = (props) => {
  const cacheKey = getCacheKey(IRefIds.courses, 0);
  const dataModel = useMemo(() => new CoursesSelectModel(), []);
  const cacheSelectData = useCacheData(cacheKey, dataModel.get.bind(dataModel));

  const options: IRefOption[] = useMemo(() => {
    if (cacheSelectData === null) {
      return [];
    }

    return cacheSelectData
      .filter((data) => data.id !== props.skipCourseId)
      .map((course) => ({ value: course.id, label: course.name }));
  }, [cacheSelectData, props.skipCourseId]);

  return (
    <RefSelectorList
      className={props.className}
      value={props.currentValue}
      onChange={props.onChange}
      options={options}
      label="CL Linked Courses"
    />
  );
};

export default CourseSelectMulti;
